module.exports = " <div class=tabbar :class=\"{'visible': state == 1}\"> <div v-for=\"($index, menu) in menus\" class=tabbar-item :style=\"{'color': menuIndex == $index ? activeMenuColor : menuColor}\" @click=menuClicked($index)> <div class=icon-wrapper> <i class=\"icon {{ menuIndex == $index ? menu.iconOn : menu.iconOff }}\"></i> </div> <div class=text-wrapper> <scalable> <span>{{ menu.text }}</span> </scalable> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/services/tabbar/Tabbar.vue
// module id = 250
// module chunks = 0